import { gatewayClient } from './api-grpc';
import { Device, GetDeviceListByPageResponse } from '../gen/proto/api/gateway/v1/gateway_pb';

export const deviceApi = {
  async create(name: string, type: string): Promise<Device> {
    const response = await gatewayClient.createDevice({
      name: name,
      data: {
        type: type,
      }
    });

    if (!response.device) {
      throw new Error('Error al crear el dispositivo: no se devolvió ningún dispositivo.');
    }
    return response.device;
  },
  async getByUuid(uuid: string): Promise<Device> {
    const response = await gatewayClient.getDeviceByUuid({
      uuid: uuid,
    });
    if (!response.device) {
      throw new Error('Error al obtener el dispositivo por UUID: no se devolvió ningún dispositivo.');
    }
    return response.device as Device;
  },
  async getListByPagination(pageIndex: number, pageSize: number): Promise<GetDeviceListByPageResponse> {
    return await gatewayClient.getDeviceListByPage({
      pageIndex: pageIndex,
      pageSize: pageSize,
    });
  },
  async update(device: Device): Promise<Device> {
    const response = await gatewayClient.updateDevice({
      uuid: device.uuid,
      name: device.name,
      data: device.data,
    });
    if (!response.device) {
      throw new Error('Error en la actualización del dispositivo: no se devolvió ningún dispositivo.');
    }

    return response.device as Device;
  },
  async delete(uuid: string): Promise<boolean> {
    const response = await gatewayClient.deleteDevice({
      uuid: uuid,
    });
    return response.success;
  },
};
